<template>
  <div id="app">
    <div v-if="$route.path === '/'" class="header add-fixed">
      <div class="logo_img" @click="logoClick">
        <div style="display:flex; align-items: center;justify-content: center; float:left; height: 65px;">
          <div class="header-logo">
            <img id="header-img" src="../assets/smallStep/conmpany-logo.png" />
          </div>
        </div>
      </div>
      <div id="menu_index">
        <!-- web端菜单导航 -->
        <el-menu v-if="seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333"
          style="height: 100%; border:0;" mode="horizontal" @select="handleSelectMenu">
          <el-menu-item class="item-menu" index="1">{{ $t('mode1') }}</el-menu-item>
          <el-menu-item class="item-menu" index="3">{{ $t('mode2') }}</el-menu-item>
          <el-menu-item class="item-menu" index="5">{{ $t('mode4') }}</el-menu-item>
          <!-- <el-menu-item class="item-menu"
            v-if="!$route.query.lan || $route.query.lan === 'all' || $route.query.lan === ''">
            <el-dropdown @command="changeLangEvent"
              style="display: inline-flex; align-items: flex-start; height: 100%; font-size: 16px; color: rgb(51, 51, 51);">
              <span class="el-dropdown-link" style="display: inline-flex; height: 100%; align-items: center;">
                {{ $t('languageText') }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="ZH">简体中文</el-dropdown-item>
                <el-dropdown-item command="EN">English</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-menu-item> -->
        </el-menu>
        <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
        <el-menu v-if="!seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333"
          style="height: 54px; border:0;" @select="handleSelectMenuMobile" mode="horizontal">
          <el-menu-item>
            <el-dropdown @command="handleSelectMenuMobile" trigger="click"
              style="display: inline-flex; align-items: flex-start; height: 100%; font-size: 16px; color: rgb(51, 51, 51);">

              <span class="el-dropdown-link" style="display: inline-flex; height: 100%; align-items: center;">
                {{ $t('home') }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>

              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">{{ $t('mode1') }}</el-dropdown-item>
                <el-dropdown-item command="3">{{ $t('mode2') }}</el-dropdown-item>
                <el-dropdown-item command="5">{{ $t('mode4') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-menu-item>
          <!-- 
          <el-menu-item v-if="!$route.query.lan || $route.query.lan === 'all' || $route.query.lan === ''">
            <el-dropdown @command="changeLangEvent" trigger="click"
              style="display: inline-flex; align-items: flex-start; height: 100%; font-size: 16px; color: rgb(51, 51, 51);">

              <span class="el-dropdown-link" style="display: inline-flex; height: 100%; align-items: center;">
                {{ $t('languageText') }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>

              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="ZH">简体中文</el-dropdown-item>
                <el-dropdown-item command="EN">English</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-menu-item> -->

        </el-menu>
      </div>
    </div>
    <div style="clear: both; padding-top: 54px;">
      <router-view></router-view>
    </div>

    <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
      <img src="../assets/smallStep/官网_slices/top.png" style="height: 43px;width: 43px" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {
      activeIndex: '1',
      company: {
        qrcode: require('../../static/other/公众号二维码.jpg')
      },
      scroll: '',
      timer: '',
      seen: true,
      language: localStorage.getItem('lang') || 'EN',
    };
  },

  created() {
    // if (this.$route.query.lan !== '' && this.$route.query.lan !== 'all') {
    //   this.changeLangEvent(this.$route.query.lan)
    // }
  },

  methods: {
    handleSelectMenu(key) {
      switch (key) {
        case '1':
          window.location.hash = '#AboutUs';
          break;
        case '3':
          window.location.hash = '#Products';
          break;
        case '5':
          window.location.hash = '#ContactUs';
          break;
      }
    },
    changeLangEvent(lan) {
      if (lan == 'ZH' || lan == 'zh') {
        localStorage.setItem('locale', 'zh');
        this.$i18n.locale = localStorage.getItem('locale');
        localStorage.setItem('lang', 'ZH');
        this.language = 'ZH';
        // location.reload(); //重新加载
      } else if (lan == 'EN' || lan == 'en') {
        localStorage.setItem('locale', 'en');
        this.$i18n.locale = localStorage.getItem('locale');
        localStorage.setItem('lang', 'EN');
        this.language = 'EN';
        // location.reload();
      }
    },
    handleSelectMenuMobile(key) {
      switch (key) {
        case '1':
          window.location.hash = '#AboutUs';
          break;
        case '3':
          window.location.hash = '#Products';
          break;
        case '5':
          window.location.hash = '#ContactUs';
          break;
      }
    },
    handleScroll() {
      this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
      if (this.scroll > 600) {
        //判断滚动后高度超过400px,就显示
        this.$refs.btn.style.display = 'block';
      } else {
        this.$refs.btn.style.display = 'none';
      }
    },

    backTop() {
      //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
      this.timer = setInterval(() => {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(this.timer);
        }
      }, 20);
    },
    login() {
      window.open('https://admin.fastice-tech.com/login');
    },
    register() {
      window.open('https://admin.fastice-tech.com/registe');
    },
    menuSeen() {
      // 屏幕尺寸
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        this.seen = true;
      } else {
        this.seen = false;
      }
    },
    logoClick() {
      this.$router.push({ name: 'Index' });
    }
  },
  mounted() {
    this.menuSeen();
    window.addEventListener('scroll', this.handleScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, true);
  }
};
</script>

<style scoped>
@import '../assets/css/main.css';

.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 2px solid #ff6b11 !important;
}

.logo_img {
  display: flex;
  height: auto;
  align-items: center;
}

.el-menu-item {
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 1em;
  font-size: 16px;
  font-weight: bold;
}

#back_to_top {
  position: fixed;
  bottom: 50px;
  right: 13%;
  cursor: pointer;
}

.footer_font {
  font-size: 1em;
}

#menu_index {
  width: auto;
  height: 100%;
}

.header {
  margin: 0 auto;
  width: 100%;
  height: 54px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #fff;
}

@media screen and (max-device-width: 415px) {
  .el-submenu__title {
    border-bottom: 2px solid #ff6b11 !important;
  }

  .header {
    display: flex;
    justify-content: center;
  }

  .logo_img {
    cursor: pointer;
    margin: 0 auto;
  }

  #back_to_top {
    position: fixed;
    bottom: 50px;
    left: 5px;
    cursor: pointer;
  }

  .footer_font {
    font-size: 0.875em;
  }

  #menu_index {
    width: auto;
    height: 100%;
  }

  .footer {
    font-size: 0.1em;
    text-align: center;
    justify-content: space-between;
  }

  .footer span {
    width: 33%;
  }
}

#header-img {
  height: 34px;
  width: 114.5px;
  float: left;
  margin: auto;
  cursor: pointer;
}

.header-important {
  float: left;
  margin-left: 6px;
  align-self: center;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px auto;
  width: 90%;
  color: #222;
  font-size: 0.88em;
  opacity: 0.6;
}

.footer span {
  text-align: center;
}

.footer span a {
  display: inline-block;
}

a {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}
</style>
